enum SceneTransition {
    /**
     * List of the available scene transition constants.
     *
     * @class SceneTransition
     */
     MOVE_FROM_RIGHT = "moveFromRight",
     MOVE_TO_LEFT = "moveToLeft",
     MOVE_FROM_LEFT = "moveFromLeft",
     MOVE_TO_RIGHT = "moveToRight",
     MOVE_FROM_TOP = "moveFromTop",
     MOVE_TO_BOTTOM = "moveToBottom",
     MOVE_FROM_BOTTOM = "moveFromBottom",
     MOVE_TO_TOP = "moveToTop",
     FADE_IN = "fadeIn",
     FADE_OUT = "fadeOut"
}

export {SceneTransition as default, SceneTransition};



// WEBPACK FOOTER //
// ./src/shared/ui/experience/SceneTransition.ts